import { vslApi } from '@/api';

export default {
  getContainerList() {
    return vslApi.get('/v1/container-sizes');
  },
};
